import { Helmet } from "react-helmet-async";

export default function SEO({
    title,
    description,
    keywords,
    image = "/og-image.jpg", // We should have a default OG image
    url,
    type = "website",
    schema,
}) {
    const siteTitle = "H-LINE | Architectural Aluminium Systems";
    const defaultDescription =
        "H-LINE (Harekrishna Enterprise) - Premium aluminium windows, doors, facades, and louvers. Minimalist designs, high-performance glazing, and precision engineering in Surat.";
    const siteUrl = "https://hline.in";

    const finalTitle = title ? `${title} | H-LINE` : siteTitle;
    const finalDescription = description || defaultDescription;
    const finalUrl = url ? `${siteUrl}${url}` : siteUrl;
    const finalImage = image.startsWith("http") ? image : `${siteUrl}${image}`;

    return (
        <Helmet>
            {/* Standard Metadata */}
            <title>{finalTitle}</title>
            <meta name="description" content={finalDescription} />
            {keywords && <meta name="keywords" content={keywords} />}
            <link rel="canonical" href={finalUrl} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={type} />
            <meta property="og:url" content={finalUrl} />
            <meta property="og:title" content={finalTitle} />
            <meta property="og:description" content={finalDescription} />
            <meta property="og:image" content={finalImage} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:url" content={finalUrl} />
            <meta name="twitter:title" content={finalTitle} />
            <meta name="twitter:description" content={finalDescription} />
            <meta name="twitter:image" content={finalImage} />

            {/* Structured Data (JSON-LD) for AI Search */}
            {schema && (
                <script type="application/ld+json">{JSON.stringify(schema)}</script>
            )}
        </Helmet>
    );
}
